import React from "react";
import { useCurrencySymbol } from "../../../intl/hooks.js";
import "../../../intl/shared-resources/serverResponse.js";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import { StyledInput } from "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import "moment-timezone";
import "react-intl";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "@mui/material";
function renderP2PTransferAmountEditableCell(params) {
  const currencySymbol = useCurrencySymbol();
  const value = params.value;
  function handleChange(amount) {
    const editValue = { id: params.id, value: { amount, currency: params.row.currency }, field: params.field };
    if (params.cellMode === "view") {
      params.api.startCellEditMode({ id: params.id, field: params.field });
    }
    setTimeout(() => {
      params.api.setEditCellValue(editValue);
    }, 0);
  }
  return /* @__PURE__ */ React.createElement(
    StyledInput,
    {
      value: value?.amount ?? 0,
      onChange: (e) => handleChange(e.target.value),
      endAdornment: currencySymbol,
      textAlign: "right",
      type: "number",
      hasBottomSpacing: false,
      fullWidth: false
    }
  );
}
export {
  renderP2PTransferAmountEditableCell
};
//# sourceMappingURL=AmountCell.js.map
